import { render, staticRenderFns } from "./contract-surrender.vue?vue&type=template&id=4e2baec0&scoped=true"
import script from "./contract-surrender.vue?vue&type=script&lang=js"
export * from "./contract-surrender.vue?vue&type=script&lang=js"
import style0 from "./contract-surrender.vue?vue&type=style&index=0&id=4e2baec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2baec0",
  null
  
)

export default component.exports